export const friendlyValue = (value: string) =>
  value
    ? value
        .split('_')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join(' ')
    : 'Unknown'

export const normalizeZoneValues = (value: any) => {
  if (Array.isArray(value)) return value
  if (!value) return []
  return String(value)
    .split(',')
    .map((zone) => zone.trim())
    .filter(Boolean)
}

export const normalizeInventorySources = (strategy: any) => {
  const normalizeSources = (value: any) => {
    if (Array.isArray(value)) return value
    if (!value) return []
    return String(value)
      .split(',')
      .map((source) => source.trim())
      .filter(Boolean)
  }

  const inventorySources = strategy.inventory_sources || {}
  const allowedSources = normalizeSources(inventorySources.allowed)
  const orderingSources = normalizeSources(inventorySources.ordering)
  const allowed = allowedSources.length ? allowedSources : ['pickable']
  const ordering = orderingSources.length ? orderingSources : allowed

  return {
    allowed,
    ordering: ordering.filter((source: string) => allowed.includes(source)),
  }
}
